import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Routes } from '@/router';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import { AccountPageLoadEvent } from '@/services/analytics/events';
import { CountryCode } from '@/store/ui';

@Component({
  name: 'CmgLoyaltyProgressWallet',
})
export default class CmgLoyaltyProgressWallet extends Vue {
  @Prop({ required: false, default: false, type: Boolean })
  pointsHistoryErrorState?: boolean;

  async mounted() {
    const isLoggedIn = await this.$services.customer.waitForCustomerInitialization();

    if(isLoggedIn) {
      this.$services.loyalty.refreshPoints();
    }
  }

  get medallionRewardShout(): string {
    return this.$appStore.state.cms.images.logos.medallionRewardShout.default;
  }

  get medallionReward(): string {
    return this.$appStore.state.cms.images.logos.medallionReward.default;
  }

  get pointsBalance(): number {
    return this.$services.reward.getPointsBalance();
  }

  get numRewards(): number {
    return this.$services.reward.getNumRedeemableRewards();
  }

  get rewardsCount() {
    return this.$appStore.state.customer.wallet.promotions.length;
  }

  get numRewardsStr(): string {
    return this.$services.reward.getNumRedeemableRewardsStr();
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get isOnRewardsExchangePage(): boolean {
    return this.$route.name == Routes.RewardsExchange;
  }

  get isOnPointsHistoryPage(): boolean {
    return this.$route.name == Routes.RewardsPointsHistory;
  }

  get chevronLeftUrl(): string {
    return this.$appStore.state.cms.images.icons.chevronLeftPlain.default;
  }

  get isServiceOnline(): boolean {
    return !this.$appStore.state.reward.unreachable;
  }

  get isRewardsExchangeOnline(): boolean {
    return this.$appStore.state.featureFlags.orderingStatus?.isRewardsExchangeOnline ?? true;
  }

  get isRewardsOnline(): boolean {
    return this.$appStore.state.featureFlags.orderingStatus?.isRewardsOnline ?? true;
  }

  get rewardsExchangeOfflineMessage(): string {
    return `We're having trouble with our Rewards ${ !this.isRewardsOnline ? '' : 'Exchange ' }but you can still order, earn points and use existing rewards. Check back later.`;
  }

  get offlineMessage(): string {
    return `We're having some trouble getting your points.`;
  }

  get sadAvocado(): string {
    return this.$appStore.state.cms.images.feedback.sadAvocado.default;
  }

  get headerText(): string {
    if (this.isOnRewardsExchangePage) {
      return 'REWARDS EXCHANGE';
    } else if (this.isOnPointsHistoryPage) {
      return  'MY REWARDS HISTORY';
    }

    return '';
  }
  
  get countryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get pointsExpirationMessage(): string {
    switch (this.countryCode) {
      case CountryCode.CA:
        return 'Points expire after one year of inactivity.';
      default:
        return '';
    }
  }

  onClickBack() {
    this.$router.push({ name: Routes.Rewards });
  }

  onClickRewardsExchange() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.RewardExchangeClick,
      label: AnalyticsEventLabel.RewardsRewardExchangeClick,
    });
    this.$router.push({ name: Routes.RewardsExchange });
  }

  onClickAddReward(event:any) {
        this.$services.googleAnalytics.sendCustomEvent({
        category: AnalyticsEventCategory.RewardsLanding,
        action: AnalyticsEventAction.AddRewardClick,
        label: AnalyticsEventLabel.AddRewardClick,
      });
      this.$services.ui.pushEventTargetAsLastSelectedElement(event);
      this.$services.ui.setModalVisibility('addReward', true);
      this.$services.analytics.send(new AccountPageLoadEvent('rewards-add-rewards'));
      this.$services.ui.firstFocus();
    }

  onClickRewardsExtras() {
    this.$router.push({ name: Routes.RewardsExtras });
  }

  onClickScanReminder() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.ForgotToScanClick,
      label: AnalyticsEventLabel.RewardsForgotToScanClick,
    });
    this.$router.push({ name: Routes.RetroCredit });
  }

  onClickPointsHistory() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.ViewPointHistoryClick,
      label: AnalyticsEventLabel.ViewPointHistoryClick,
    });
    this.$services.ui.nextFocus('points');
    this.$router.push({ name: Routes.RewardsPointsHistory });
  }
}
